import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

/** Same annotation the github-actions, github-insights and code-coverage cards key off. */
const PROJECT_SLUG_ANNOTATION = 'github.com/project-slug';

// The Service view is a tab (room for per-image and per-ecosystem detail);
// ServiceGroup and System share one overview rollup card.
const serviceTab = EntityContentBlueprint.make({
  name: 'service',
  params: {
    path: '/chainguard',
    title: 'Chainguard',
    // Kind too: a System or ServiceGroup with the annotation gets a rollup, not a service summary.
    filter: (entity: {
      kind: string;
      metadata?: { annotations?: Record<string, string> };
    }) =>
      entity.kind.toLowerCase() === 'component' &&
      Boolean(entity.metadata?.annotations?.[PROJECT_SLUG_ANNOTATION]),
    loader: async () => {
      const { ServiceChainguardTab } = await import('./features/service-tab');
      return compatWrapper(<ServiceChainguardTab />);
    },
  },
});

const rollupCard = EntityCardBlueprint.make({
  name: 'rollup',
  params: {
    filter: { kind: { $in: ['servicegroup', 'system'] } },
    loader: async () => {
      const { RollupChainguardCard } = await import('./features/rollup-card');
      return compatWrapper(<RollupChainguardCard />);
    },
  },
});

export const chainguardPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'chainguard',
  extensions: [serviceTab, rollupCard],
});
